export default __webpack_public_path__ + "static/media/logo-deltafire-branco.467db1ce.png";